import { useTranslation } from "react-i18next";

import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { object, string } from "yup";
import { Button, Form, Input } from "../../../../common/components";
import { DialogTitleWithCloseButton } from "../../../../common/components/Dialog/DialogTitleWithCloseButton";
import { useForm } from "../../../../common/hooks/useForm";
import DesignService from "../../../../service/DesignService";

const validationSchema = object({
  lockedVersion: string().required("general.errors.required.input"),
});

interface Props {
  open: boolean;
  onClose: () => void;
  oldVersion?: string;
  designId: string;
  onUpdate: () => Promise<void>;
}

const LockDesignModal = ({
  open,
  onClose,
  oldVersion = "",
  designId,
  onUpdate,
}: Props) => {
  const { t } = useTranslation();

  const formik = useForm({
    initialValues: { lockedVersion: oldVersion },
    onSubmit: async (values) => {
      await DesignService.lockDesign(designId, true, values.lockedVersion);

      onClose();
      await onUpdate();
    },
    validationSchema,
  });

  useEffect(() => {
    formik.setFieldValue("lockedVersion", oldVersion);
    // eslint-disable-next-line
  }, [oldVersion]);

  useEffect(() => {
    return () => {
      formik.resetForm({
        values: {
          lockedVersion: "",
        },
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth={"md"}>
      <Form formik={formik}>
        <DialogTitleWithCloseButton
          id="customized-dialog-title"
          onClose={onClose}
          sx={{ mb: 2 }}
        >
          {t("design.lock_design_modal_title")}
        </DialogTitleWithCloseButton>
        <DialogContent sx={{ pr: 0 }}>
          <Input
            type="text"
            name="lockedVersion"
            sx={{ maxWidth: "unset" }}
            value={formik.values["lockedVersion"]}
            placeholder={t("design.lock_design_modal_placeholder")}
            noMaxWidth
            data-test="lock.input"
          />
        </DialogContent>
        <DialogActions>
          <Button type="submit">
            <Typography variant="actionBoldBigIcon">
              {t("design.lock")}
            </Typography>
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  );
};

export default LockDesignModal;
